import { useKycGetKycInfoByUserIdQuery, EKycVerificationStatus } from '@e-kyc/graphql';

export function useEkycStatus(userId: string) {
  const { data, loading, error, refetch } = useKycGetKycInfoByUserIdQuery({
    skip: !userId,
    variables: {
      getKycInfoByUserIdInput: {
        userId,
      },
    },
    fetchPolicy: 'network-only',
  });

  const eKycStatus = data?.kycGetKycInfoByUserId?.status;

  const isCompleted =
    eKycStatus === EKycVerificationStatus.Approved ||
    eKycStatus === EKycVerificationStatus.PendingApproval;

  return {
    eKycStatus,
    eKycInfo: data?.kycGetKycInfoByUserId,
    isCompleted,
    loading,
    error,
    refetch,
  };
}
